import { useEffect, useState } from 'react';

export const filterId = (idProp: string, separator: string = '-') =>
  idProp.toLowerCase().replace(/\W/g, separator);

export function useFilterId(idProp: string, separator?: string) {
  const [filteredId, setFilteredId] = useState(filterId(idProp, separator));

  useEffect(() => {
    setFilteredId(filterId(idProp, separator));
  }, [idProp, separator]);

  return filteredId;
}
